import interceptedAxios from '../../../utils/interceptedAxios'

export async function exportCustomDeviceData (
  deviceID: string,
  fileName: string,
  onSuccess: (exportFile: any) => any,
  onFailure: (errorMessage: string) => any
): Promise<void> {
  const fileNameOnly = fileName.split('.').shift() ?? ''
  const url = `/asset-config-service/api/v1/udp/tiq/commands/configuration/device-template/export/${deviceID}`
  interceptedAxios
    .get(url, { responseType: 'blob', timeout: 10000 })
    .then((response) => {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: 'text/csv' })
      )
      const link = document.createElement('a')
      link.href = url
      link.setAttribute(
        'download',
        `${fileNameOnly}.csv`
      )
      document.body.appendChild(link)
      link.click()
      link.parentNode?.removeChild(link)
      onSuccess(response)
    })
    .catch((error) => {
      onFailure(error)
    })
}
